module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "fm-title",
    attrs: {
      "id": "ack"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_xviii"
    }
  }), _c('img', {
    attrs: {
      "alt": "images",
      "src": "images/com-a.jpg"
    }
  }), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("First and foremost, as editors, we’d like to thank our colleagues at Emerging Civil War, past and present. ECW has always been and remains a team effort. We’ve worked with some wonderful historians, writers, and “emerging voices” over the past decade, and we’re proud to show off some of that work here.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Thanks, too, to Theodore Savas and his entire team at Savas Beatie, with a special thanks to our editorial liaison, Sarah Keeney. Ted took a chance on us when we were still a young blog, accepting Kris White’s pitch for the Emerging Civil War Series. That proved to be a game-changer for us. Together, ECW and Savas Beatie have produced some great work, and we’re thankful to Ted for agreeing to help us celebrate ECW’s tenth anniversary by allowing us to produce more great work. We thank everyone at Savas Beatie for all they do to support the work of Emerging Civil War.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Sarah Kay Bierle, as ECW’s managing editor, manages the content on the blog on a daily basis. Her work made it a lot easier for us to collect the material we’ve assembled in this volume. Our official un-official archivist, Jon-Erik Gilot, has helped us make it easier to access our past work.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Kris White, as our chief historian, provides overall quality control for our work, offering a soft but firm guiding hand. Christopher Kolakowski and Dan Davis previously served in that role. Our thanks to all three of them for ensuring a high bar for our writers in service to our readers.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Thanks to John Foskett and Patrick McCormick, who both reviewed the text and made valuable suggestions and observations. Thanks also to Denise Hardy for her transcriptions. And a big thank-you to Chris Heisey for always being willing to contribute "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("one more")]), _vm._v(" photograph as the design of this book continuted to evolve.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Finally, a special thanks to co-founders Chris Mackowski, Jake Struhelka, and Kristopher D. White, whose brainstorming over beers, cigars, and history "), _c('a', {
    attrs: {
      "id": "page_xix"
    }
  }), _vm._v("led to ECW’s creation. To quote Kris’s wife, “Not too bad for three idiots sitting on a porch.”")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-c"
  }, [_vm._v("* * *")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Dwight:")]), _vm._v(" I wish to thank most of all our Emerging Civil War colleagues who contributed to this volume. (See Contributor section at the back for their stories.) It was a real pleasure working with them. For my first crack at it, I found that book editing can be fun (usually) and instructive (always), particularly when compiling such excellent material collected by the ECW blog over the years.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Thanks also to our esteemed leader and editor in chief, Chris Mackowski, and to our publisher, Ted Savas, who have been so supportive. They approved the idea for this book in twenty minutes with one email and one phone call. Their enthusiasm in highlighting the naval side of the Civil War, and the wonderful podium they created, fulfilled a dream to become a historian/author in the subject as a third career. My sincere appreciation to all the friends and staff at Emerging Civil War and Savas Beatie for their encouragement and support.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("And to a loving wife, Judi, who endured my zombie presence at the keyboard all those many days. Thank you.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-c"
  }, [_vm._v("* * *")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chris:")]), _vm._v(" My thanks to Dwight Hughes for bringing his passion for the Civil War’s naval story to Emerging Civil War. The many lost sailors during the conflict will never be forgotten thanks to Dwight’s tireless efforts.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Thanks to Aaron Chimbel, dean of the Jandoli School of Communication at St. Bonaventure University, for his ongoing strong support of my work. Thanks, too, to former deans Pauline Hoffmann and Lee Coppola for the similarly strong support they showed during their tenures, when some of this content was initially generated.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Finally, as always, my thanks to my family, especially my kids, Stephanie, Thomas, and Sophie Marie (my first grandchild!); Jackson; and Maxwell James. Most of all, thanks to my wife and partner, Jenny Ann, the captain of my soul."), _c('a', {
    attrs: {
      "id": "page_xx"
    }
  })]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "id": "page_xxi"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "image_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f00xx-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "captionC"
  }, [_vm._v("St. Augustine, Florida "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Chris Heisey")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2be91af7","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/09_Acknowledgments.vue
// module id = 84
// module chunks = 0